import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid, Button } from "@mui/material";
import { withStyles } from "@mui/styles";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const styles = (theme) => ({
  cardFooter: {
    textAlign: "center",
    textDecoration: "none",
    marginLeft: "auto",
    marginRight: "auto",
    placeItems: "center",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "15px",
    },
  },
  waImage: {
    fontSize: "2.5rem !important",
    position: "absolute",
    top: "10%",
    left: "10%",
    alignSelf: "center",
    margin: "auto",
    verticalAlign: "middle",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem !important",
    },
  },
  waButton: {
    display: "inline-block",
    position: "relative",
    color: "#1d2b4f",
    background: "#fff",
    width: "50px",
    height: "50px",
    borderRadius: "25px",
    cursor: "pointer",
    marginRight: "10px",
    verticalAlign: "middle",
  },
  footerContainer: {
    backgroundColor: "#0D3D66",
    color: "#fff",
    paddingBottom: "20px",
    height: "90px",
    paddingTop: "20px",
    marginTop: "60px",
    [theme.breakpoints.down("sm")]: {
      height: "180px",
    },
  },
});

function Footer(props) {
  const { width, classes, openTermsDialog, messages } = props;
  return (
    <div className={classes.footerContainer}>
      <div className="container-fluid lg-p-top">
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12} md={4} className={classes.cardFooter}>
            <span className="copyright">
              Copyright &copy; IMAR Sistemas {new Date().getFullYear()}{" "}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className={classes.cardFooter}>
            <a
              target="_blank"
              className={classes.waButton}
              rel="noopener noreferrer"
              href="https://twitter.com/IMAR_Sistemas"
            >
              <TwitterIcon className={classes.waImage} />
            </a>

            <a
              target="_blank"
              className={classes.waButton}
              rel="noopener noreferrer"
              href="https://www.facebook.com/IMARSistemas"
            >
              <FacebookIcon className={classes.waImage} />
            </a>

            <a
              target="_blank"
              className={classes.waButton}
              rel="noopener noreferrer"
              href="https://www.instagram.com/imar_sistemas"
            >
              <InstagramIcon className={classes.waImage} />
            </a>
          </Grid>
          <Grid item xs={12} md={4} className={classes.cardFooter}>
            <li className="list-inline-item" onClick={openTermsDialog}>
              {messages.politicas}
            </li>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  openTermsDialog: PropTypes.func.isRequired,
  theme: PropTypes.object,
  messages: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Footer);
